import { Offer, Payment, PaymentTypeOptions, VehicleState } from "Types/state";

export const getSelectedPaymentType = (vehicle: VehicleState) => {
    return (vehicle.payments && vehicle.payments.selected) || "cash";
};

export const getDownPayment = (vehicle: VehicleState, type: "loan" | "lease"): number | null => {
    return (vehicle && vehicle.payments && vehicle.payments[type] && vehicle.payments[type]!.down_payment) || null;
};

export const getPaymentData = (vehicle: VehicleState): Payment | null => {
    const selectedPaymentName = getSelectedPaymentType(vehicle);

    return (vehicle && vehicle.payments && vehicle.payments[selectedPaymentName]) || null;
};

export const getOfferData = (vehicle: VehicleState): Offer | null => {
    const payment = getPaymentData(vehicle);
    const selectedOfferIndex = payment && payment.selected_offer;

    return (selectedOfferIndex != null && payment && payment.offers && payment.offers[selectedOfferIndex]) || null;
};

export function getPaymentPrice(vehicle: VehicleState): number | undefined | null {
    const payment = getPaymentData(vehicle);
    return payment && payment.price;
}

interface ByEnabledPaymentTypeVehicle {
    payments?: {
        cash?: {
            enabled?: boolean;
        };
        lease?: {
            enabled?: boolean;
        };
        loan?: {
            enabled?: boolean;
        };
    };
}

export function byEnabledPaymentType(paymentType: Exclude<PaymentTypeOptions, undefined>) {
    return (vehicle: ByEnabledPaymentTypeVehicle) => {
        const payment = vehicle.payments && vehicle.payments[paymentType];

        return Boolean(payment && payment.enabled);
    };
}
